import React from 'react';

const Context = React.createContext();

export const EditorProvider = Context.Provider;

export const useEditorContext = () => React.useContext(Context);
